import React, { useEffect, useCallback, useState } from 'react';
import { Col, Label, Row, Badge } from 'reactstrap';
import { EN, ES } from '../../Etiquetas/Labels';
import { FormEnglish, FormEsp } from '../../Form';
import ControlledAccordions from './Components/Accordion';
import { ModelCreateTicket } from '../CreateTicket/model';
import { Link, useParams } from "react-router-dom";
import ModalCloseTicket from './Components/closeticket';
// import Swal from 'sweetalert2/dist/sweetalert2.js';
// import 'sweetalert2/src/sweetalert2.scss';
import Axios from "axios";
import ContentWrapper from '../../Components/ContenWraper/ContentWrapper'

// import { ModelDetailTicket } from './model';
import Loader from '../../loaders';
import { Services } from '../../Services';


const ColorEstatus = {
  1: '#2ca8ff',
  2: '#2ca8ff',
  3: '#2ca8ff',
  4: '#2ca8ff',
  5: '#2ca8ff',
  6: '#0561fccc'
}

const colorsButtons = {
  1: { Create: 'primary', Cancel: 'primary' },
  // 2: { Create: 'primary', Cancel: 'danger' },
  2: { Cancel: 'danger', CancelYes: 'primary', CancelNo: 'danger', UploadDoc: 'primary', CancelDoc: 'danger' },
  3: { Create: 'primary', Cancel: 'warning' },
  4: { Create: 'success', Cancel: 'warning' },
  5: { Create: 'success', Cancel: 'warning' },
  6: { Cancel: 'primary', CancelYes: 'primary', CancelNo: 'secondary', UploadDoc: 'primary', CancelDoc: 'secondary' },
};

function TicketDetailsComponent(props) {
  // console.log('props detail ticket--->', props);

  const { id } = useParams();
  const [modelDetail] = React.useState({ ...ModelCreateTicket() });
  const [Labels, setLabels] = useState(EN);
  const [Form, setForm] = React.useState(FormEnglish);
  const [validate, setValidate] = React.useState(false);
  const [Ticket, setTicket] = useState([{ TicketNumber: '', CreatedBy: '', Subjet: '', Status: '', Type: '', CreationDate: '', CloseDate: '' },]);
  // const [idRason, setIdRason] = useState(0);
  const [closed, setClosed] = useState(false);
  const [ActiveLoader, setActiveLoader] = React.useState(false)
  const [idProject, setIdProject] = useState(0);
  const [newComment, setNewComment] = React.useState('');
  const [disabledButton, setDisabledButton] = React.useState(true);
  const [tz] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone)


  const GetTicketId = useCallback(async (idProject) => {
    try {
      // console.log('projectId-->', idProject);
      let body = {
        idProject: idProject,
        timezone: tz
      }
      let Ticket = await Axios.post(`${Services.TICKETS.path}Ticket/ticketid/${id}`, { timezone: tz });
      // console.log('dataTicket', Ticket.data.data);

      let resultCatalogos = await Axios.post(`${Services.TICKETS.path}catalogos/catalogos/`, body);
      resultCatalogos.data.data.dataCatReasonsCloses.map((e) => {
        modelDetail.Catalogs.ReasonsCloses.push({ 'key': e.ReasonCloseId, 'value': e.ReasonCloseId, 'text': e.ReasonClose });
        return e;
      });
      if (Ticket.data.data[0].CatStatusId === 3 || Ticket.data.data[0].CatStatusId === 4) {
        setClosed(true);
      } else {
        setClosed(false);
      }
      setTicket(Ticket.data.data);
      setActiveLoader(true)
    } catch (error) {
      console.log('The Error-->', error);
    }
  }, [idProject, tz, id]);

  // const ClosedTicket = (evt, data, type) => {
  //   let TicketNumber = Ticket[0].TicketNumber
  //   Axios.post(`${Services.Tickets.path}Ticket/closedticket/${id}`, { Rason: idRason })
  //     .then((resp) => {
  //       GetTicketId();
  //       Swal.fire({
  //         icon: 'success',
  //         title: Labels.alerts.closed_ticket.header,
  //         text: Labels.alerts.closed_ticket.message + ' ' + `#${TicketNumber}`,
  //         // footer: '<a href>Why do I have this issue?</a>'
  //       });
  //     })
  //     .catch((error) => {
  //       console.warn(error);
  //     });
  // };

  function CancelTicket() {
    let body = {
      comm: newComment,
      ByHelpDesk: 0,
      ByUser: 1
    }
    Axios.put(`${Services.TICKETS.path}Ticket/cancelticket/${id}`, body)
      .then((response) => {
        // console.log('response', response);
        GetTicketId()
        // getComments()
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  function handleChange(evt, data) {
    // console.log('handle change', data.value);
    setNewComment(data.value);
    if (data.value) {
      setDisabledButton(false)
    } else {
      setDisabledButton(true)
    }
    // let value = data.value;
    // setIdRason(value);
  }

  const getProjects = useCallback(async (idProject) => {
    setIdProject(idProject)
    try {
      let Projets = await Axios.get(`${Services.TICKETS.path}project/getproject/${idProject}`);
      // console.log('this i the project--->', Projets.data.data[0].LanguageCode);
      setLabels(Projets.data.data[0].LanguageCode === 'ES' ? ES : EN)
      setForm(Projets.data.data[0].LanguageCode === 'ES' ? FormEsp : FormEnglish)
      setValidate(Projets.data.data[0].LanguageCode === 'EN' ? true : false)
      GetTicketId(idProject);
    } catch (error) {
      console.log('The Error-->', error);
    }
  }, []);

  useEffect(() => {
    getProjects(props.ProjectId)
    // setLabels(props._language === 'Ingles' ? EN : ES)
    // setForm(props._language === 'Ingles' ? FormEnglish : FormEsp)
    // setValidate(props._language === 'Ingles' ? true : false)
    // GetTicketId();
  }, [props]);

  return (
    // <div style={{ background: '#f5f5f5' }}>

    <ContentWrapper>
      <Loader hidden={ActiveLoader} projectId={props.ProjectId} />
      <div className="content-heading">
        <div className={props.style ? props.style.titleModule : ''}>
          <i className={Labels.header.icon} />
          <b>{Labels.details.title}</b>
        </div>
      </div>
      {/* <Col xs={12} md={12}> */}
      {/* <CardHeader>
          <CardTitle>
            <CardBody>
              <i className={Labels.header.icon} />
              <b>{Labels.details.title}</b>
            </CardBody>
          </CardTitle>
        </CardHeader> */}
      {/* <CardBody> */}
      <Row>
        <Col xs={10}>
          <Row>
            <Col xs={4} md={3} lg={3} style={{ padding: '0' }}>
              <Link to={'/Service-Desk'} style={{ textDecoration: 'none' }} >
                {/* <Col> */}
                {/* <Row> */}
                {/* <i className='fas fa-chevron-left' style={{ color: '#3792d6' }} /> */}
                <Label style={{ color: ColorEstatus[props.ProjectId], cursor: 'pointer' }}><i className='fas fa-chevron-left' /><b>Ticket</b> {`${Ticket[0].TicketNumber} `}</Label>
                {/* </Row> */}
                {/* </Col> */}
              </Link>
              <Badge style={{ width: '100%', background: ColorEstatus[props.ProjectId], fontSize: '1rem', padding: '0.3em' }} pill>{Ticket[0].Status}</Badge>
            </Col>
            <Col xs={8} md={9} lg={9}>
              <Col xs={12}>
                <b>{` ${Ticket[0].Subjet}`}</b>
              </Col>
              <Col xs={12}>
                <Label>
                  {closed ? `${Labels.details.lbl_close} ` : `${Labels.details.last_update} `}
                  {`${Ticket[0].updatedate} `}
                </Label>
              </Col>
            </Col>
          </Row>
        </Col>
        <Col xs={2}>
          <ModalCloseTicket
            Ticket={Ticket[0]}
            catalogos={modelDetail.Catalogs}
            labels={Labels}
            CancelTicket={CancelTicket}
            onChange={handleChange}
            idProject={props.ProjectId}
            disabledButton={disabledButton}
            colorsButtons={colorsButtons[props.ProjectId]}
          />
          {/* <Button color='red' floated='right'>
              {Labels.details.btn_close_ticket}
            </Button> */}
        </Col>
      </Row>
      <hr></hr>
      {/* </CardBody> */}
      <ControlledAccordions dataTikets={Ticket[0]} id={id} Closed={closed} Labels={Labels} Form={Form} validate={validate} GetTicketId={GetTicketId} colorsButtons={colorsButtons[props.ProjectId]} />
      {/* </Col > */}
    </ContentWrapper>
    // </div>

  );
}

export default TicketDetailsComponent;